module.exports = __webpack_public_path__ + "media/img/about/social/facebook-7f68a2e4b4ac9ad6c5307ce34eba5975.png";